<template>
  <z-expansion-config-item 
    :titulo="configuracao.descricao" 
    :subtitulo="configuracao.ajuda"
  >
    <v-select
      v-model="store.configuracoes.BLOQUEAR_TELA"
      dense
      filled
      hide-details
      style="width: 200px"
      :items="timers"
      @change="updateConfig"
    ></v-select>
  </z-expansion-config-item>
</template>

<script setup>
import { mounted } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import { globals } from '@/app/globals'

const store = useConfigStore();

const timers = [
  { text: 'Nunca', value: 0 },
  { text: '2 minutos', value: 2 },
  { text: '5 minutos', value: 5 },
  { text: '10 minutos', value: 10 },
  { text: '15 minutos', value: 15 },
  { text: '30 minutos', value: 30 },
]

const configuracao = {
  config: 'BLOQUEAR_TELA',
  valor: store.configuracoes.BLOQUEAR_TELA,
  tipo: 'integer',
  descricao: 'Bloqueio de tela por inatividade',
  ajuda: 'Define o tempo de inatividade em minutos para bloquear a tela do sistema'
}

function updateConfig() {
  configuracao.valor = store.configuracoes.BLOQUEAR_TELA;
  store.salvarConfiguracao(configuracao);
}

</script>

<style lang="scss" scoped>

</style>
